import React, { useState } from "react";
import { IMaskInput } from "react-imask";

type MaskedInputProps = React.ComponentProps<typeof IMaskInput>;

const MaskedInput = React.forwardRef<HTMLInputElement, MaskedInputProps>(
  function MaskedInput({ onFocus, onBlur, ...rest }, ref) {
    const [focused, setFocused] = useState(false);
    return (
      <IMaskInput
        {...rest}
        ref={ref}
        lazy={!focused}
        onFocus={(e: React.FocusEvent<HTMLInputElement>) => {
          setFocused(true);
          onFocus?.(e);
        }}
        onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
          setFocused(false);
          onBlur?.(e);
        }}
      />
    );
  }
);

export default MaskedInput;
